
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire80ef"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire80ef"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("LMLC2", function(module, exports) {

$parcel$export(module.exports, "getFromLocalStroage", () => $08fa37fff71de28c$export$c9df1acf5da6cedc);
$parcel$export(module.exports, "addToLocalStorage", () => $08fa37fff71de28c$export$b4aebac53294aa19);
$parcel$export(module.exports, "currentMonthAndYear", () => $08fa37fff71de28c$export$29a877d48cc0fbf1);
$parcel$export(module.exports, "disableAllFormFields", () => $08fa37fff71de28c$export$a31069e9731ec9b0);
$parcel$export(module.exports, "loadMonthAndYear", () => $08fa37fff71de28c$export$67062a373be90271);
$parcel$export(module.exports, "loadNavigation", () => $08fa37fff71de28c$export$f2824e4cda609046);
$parcel$export(module.exports, "hidePreloader", () => $08fa37fff71de28c$export$e0ccb1a4f1e8a222);

var $s9t2A = parcelRequire("s9t2A");
const $08fa37fff71de28c$export$c9df1acf5da6cedc = async (storage_key)=>{
    const value = await window.localStorage.getItem($08fa37fff71de28c$export$902ba6ec74c93f9d(storage_key));
    return JSON.parse(value);
};
const $08fa37fff71de28c$export$b4aebac53294aa19 = async (storage_key, value)=>{
    await window.localStorage.setItem($08fa37fff71de28c$export$902ba6ec74c93f9d(storage_key), JSON.stringify(value));
};
const $08fa37fff71de28c$export$902ba6ec74c93f9d = (storage_key)=>{
    return `${0, $s9t2A.APPLICATION_NAME}-${storage_key}`;
};
const $08fa37fff71de28c$export$23cfe696632d10f4 = (object = {})=>{
    Object.keys(object).length;
};
const $08fa37fff71de28c$export$29a877d48cc0fbf1 = ()=>{
    const today = new Date();
    const monthAndYear = today.toLocaleString("en", {
        month: "long",
        year: "numeric"
    });
    return monthAndYear;
};
const $08fa37fff71de28c$export$a31069e9731ec9b0 = async (form)=>{
    if (!form) {
        console.warn("[disableAllFormFields]", "please pass a valid form element");
        return;
    }
    const allFormFields = form.querySelectorAll("input, select");
    allFormFields.forEach((formField)=>{
        formField.setAttribute("disabled", "disabled");
    });
};
const $08fa37fff71de28c$export$67062a373be90271 = ()=>{
    const monthAndYearParagraph = document.querySelector("#month-and-year");
    monthAndYearParagraph.innerText = $08fa37fff71de28c$export$29a877d48cc0fbf1();
};
const $08fa37fff71de28c$export$f2824e4cda609046 = ()=>{
    const mainNavigation = document.querySelector("#main-navigation");
    const currentPage = window.location.pathname.replace("/", "");
    const listItemsArray = (0, $s9t2A.PAGES).map((page)=>{
        const isActivePage = currentPage === page.url;
        return `<li class="main-navigation__list__item">
		<a href="${page.url}" class="${isActivePage ? "main-navigation__list__item--active" : ""}" disabled="${isActivePage ? "disabled" : ""}">${page.name}</a>
	</li>`;
    });
    const listItems = listItemsArray.join("");
    const navigationList = `
	<ul class="main-navigation__list">
	${listItems}
	</ul>
	`;
    mainNavigation.innerHTML = navigationList;
};
const $08fa37fff71de28c$export$e0ccb1a4f1e8a222 = ()=>{
    const preloader = document.querySelector("#preloader");
    const preloaderChildren = preloader.childNodes;
    setTimeout(()=>{
        preloaderChildren.forEach((child)=>{
            child.style.display = "none";
        });
        preloader.classList.add("preloader--hide");
    }, 1000);
};

});
parcelRegister("s9t2A", function(module, exports) {

$parcel$export(module.exports, "APPLICATION_NAME", () => $0549f5aaef62b2d2$export$9b9733afa16e817c);
$parcel$export(module.exports, "STORAGE_KEYS", () => $0549f5aaef62b2d2$export$5aae9b6b3e0e7094);
$parcel$export(module.exports, "ACCOUNT_NUMBER_LENGTH", () => $0549f5aaef62b2d2$export$ccf5f098cdeec6fc);
$parcel$export(module.exports, "PAGES", () => $0549f5aaef62b2d2$export$bf0267afb2fbc151);
const $0549f5aaef62b2d2$export$9b9733afa16e817c = "smog-buffet";
const $0549f5aaef62b2d2$export$5aae9b6b3e0e7094 = {
    CURRENT_MONTH: "current-month"
};
const $0549f5aaef62b2d2$export$ccf5f098cdeec6fc = 10;
const $0549f5aaef62b2d2$export$bf0267afb2fbc151 = [
    {
        url: "index.html",
        name: "Home"
    },
    {
        url: "about.html",
        name: "About"
    },
    {
        url: "contribute.html",
        name: "Contribute"
    }
];

});



var $LMLC2 = parcelRequire("LMLC2");
window.addEventListener("load", async ()=>{
    (0, $LMLC2.loadMonthAndYear)();
    (0, $LMLC2.loadNavigation)();
    (0, $LMLC2.hidePreloader)();
});


//# sourceMappingURL=about.5c528c5f.js.map
